import { ChangeDetectionStrategy, Component } from '@angular/core'
import { NzModalModule } from 'ng-zorro-antd/modal'

@Component({
  selector: 'aiomed-charger-connected',
  imports: [NzModalModule],
  templateUrl: './charger-connected.component.html',
  styleUrl: './charger-connected.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChargerConnectedComponent {}
